import { ISlotsStatePersisted } from 'features/slots/types'

type ReturnMigrationType = (state: ISlotsStatePersisted) => ISlotsStatePersisted

export const slotsMigrations: Record<string, ReturnMigrationType> = {
  1: state => ({
    ...state,
    data: {
      ...state.data,
      gameList: [],
    },
  }),
  2: state => ({
    ...state,
    data: {
      ...state.data,
      gameList: [],
    },
  }),
  3: state => ({
    ...state,
    data: {
      ...state.data,
      gameList: [],
    },
  }),
  10: state => ({
    ...state,
    data: {
      ...state.data,
      gameList: [],
    },
  }),
  11: state => ({
    ...state,
    data: {
      ...state.data,
      gameList: [],
    },
  }),
  12: state => ({
    ...state,
    data: {
      ...state.data,
      gameList: [],
    },
  }),
  15: state => ({
    ...state,
    data: {
      ...state.data,
      gameList: [],
      externalGames: {
        top: {
          lastLoadDate: null,
          games: [],
        },
        new: {
          lastLoadDate: null,
          games: [],
        },
        categories: {
          lastLoadDate: null,
          categoriesData: {},
        },
      },
    },
  }),
  16: state => ({
    ...state,
    data: {
      ...state.data,
      gameList: [],
      externalGames: {
        top: {
          lastLoadDate: null,
          games: [],
        },
        new: {
          lastLoadDate: null,
          games: [],
        },
        categories: {
          lastLoadDate: null,
          categoriesData: {},
        },
      },
    },
  }),
  17: state => ({
    ...state,
    data: {
      ...state.data,
      gameList: [],
      externalGames: {
        top: {
          lastLoadDate: null,
          games: [],
        },
        new: {
          lastLoadDate: null,
          games: [],
        },
        categories: {
          lastLoadDate: null,
          categoriesData: {},
        },
      },
    },
  }),
  18: state => ({
    ...state,
    data: {
      ...state.data,
      gameList: [],
      externalGames: {
        top: {
          lastLoadDate: null,
          games: [],
        },
        new: {
          lastLoadDate: null,
          games: [],
        },
        categories: {
          lastLoadDate: null,
          categoriesData: {},
        },
        wager: {
          lastLoadDate: null,
          games: [],
        },
      },
    },
  }),
  19: state => ({
    ...state,
    data: {
      ...state.data,
      gameList: [],
      externalGames: {
        top: {
          lastLoadDate: null,
          games: [],
        },
        new: {
          lastLoadDate: null,
          games: [],
        },
        categories: {
          lastLoadDate: null,
          categoriesData: {},
        },
        wager: {
          lastLoadDate: null,
          games: [],
        },
      },
    },
  }),
  20: state => ({
    ...state,
    data: {
      ...state.data,
      gameList: [],
      externalGames: {
        top: {
          lastLoadDate: null,
          games: [],
        },
        new: {
          lastLoadDate: null,
          games: [],
        },
        categories: {
          lastLoadDate: null,
          categoriesData: {},
        },
        wager: {
          lastLoadDate: null,
          games: [],
        },
      },
    },
  }),
  21: state => ({
    ...state,
    data: {
      ...state.data,
      gameList: [],
      externalGames: {
        top: {
          lastLoadDate: null,
          games: [],
        },
        new: {
          lastLoadDate: null,
          games: [],
        },
        categories: {
          lastLoadDate: null,
          categoriesData: {},
        },
        wager: {
          lastLoadDate: null,
          games: [],
        },
      },
    },
  }),
  22: state => ({
    ...state,
    data: {
      ...state.data,
      gameList: [],
    },
  }),
  23: state => ({
    ...state,
    data: {
      ...state.data,
      gameList: [],
    },
  }),
}
